import React from 'react';
import AdminHeader from '../components/AdminHeader';
import ClientHeader from '../components/ClientHeader';
import NavSidebar from '../components/NavSidebar';
import { usePageMeta } from '../components/DashboardShell';
import { useView } from '../contexts/ViewContext';
import EffortContent from '../components/hub/effort/EffortContent';

/**
 * Effort in the customer-dashboard chrome: the legacy header + NavSidebar, with the
 * shared <EffortContent> as the main column. The same surface also renders inside the
 * ClientHub HubShell via <EffortHubPage>; both wrappers stay thin because all the
 * page logic lives in EffortContent.
 */
export default function EffortPage() {
  usePageMeta({ headerActive: 'Effort', sidebarActive: 'effort' });
  const view = useView();
  const username = localStorage.getItem('username') || 'User';
  const HeaderComp = view.isClient ? ClientHeader : AdminHeader;

  return (
    <main className="flex-1 min-w-0">
          <EffortContent />
        </main>
  );
}
